import React from "react";
import { useSelector } from "react-redux";
import Loading from "../otros/Loading";
import { Navigate } from "react-router-dom";

const SupervisorRoute = ({ Component }) => {
  const { user } = useSelector((state) => ({ ...state }));

  return user && user.token && user.rol === "Supervisor" ? (
    <Component />
  ) : (
    <Navigate to="/" />
  );
};

export default SupervisorRoute;
